import { render } from "./purchasetransaction.vue?vue&type=template&id=2b32afd3&scoped=true"
import script from "./purchasetransaction.vue?vue&type=script&lang=js"
export * from "./purchasetransaction.vue?vue&type=script&lang=js"

import "./purchasetransaction.vue?vue&type=style&index=0&id=2b32afd3&scoped=true&lang=css"
import "./purchasetransaction.vue?vue&type=style&index=1&id=2b32afd3&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b32afd3"]])

export default __exports__